<template>
  <div class="flex gap-2">
    <a href="">
      <img :src="require('@/assets/icons/facebook.svg')" height="30" width="30" alt="facebook">
    </a>
    <a href="">
      <img :src="require('@/assets/icons/linkdin.svg')" height="30" width="30" alt="linkedin">
    </a>
    <a href="">
      <img :src="require('@/assets/icons/instagram.svg')" height="30" width="30" alt="instagram">
    </a>

  </div>
</template>

<script>
import ContentBlock from '~/components/ContentBlock.vue';

export default {
  components: {
    ContentBlock,
  },
};
</script>
